export class Licenza {
  id: number;
  organizzazioneId: number;
  activationDate: Date;
  expiryDate: Date;
  maxSedi: number;
  maxRisorse: number;
  maxDispositivi: number;
  /**
   * Rifinitura sottrattiva del menù per l'organizzazione, in JSON (vedi MenuConfig).
   * Va sempre rispedita al backend nei salvataggi della licenza, altrimenti si azzera.
   */
  menuConfig?: string | null;
}
